import React from 'react';

const SaveMediumIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16663 16.25V5.83337C4.16663 4.45266 5.28591 3.33337 6.66663 3.33337H13.3333C14.714 3.33337 15.8333 4.45266 15.8333 5.83337V16.25C15.8334 16.4063 15.7462 16.5494 15.6073 16.6209C15.4684 16.6923 15.3012 16.6801 15.1741 16.5892L10.2425 13.0659C10.0974 12.9621 9.90247 12.9621 9.75746 13.0659L4.82579 16.5884C4.69889 16.6792 4.53187 16.6915 4.39303 16.6202C4.25419 16.549 4.16681 16.4061 4.16663 16.25Z"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export default SaveMediumIcon;
